<template>
    <v-card>
        <v-card-title>
            {{ `${this.$props.editTagClone.issue_tag_id ? 'Edit Tag': 'Add Tag'}` }}
        </v-card-title>

        <v-divider />

        <v-card-text class="mt-4">
            <v-form ref="issueTagForm" class="fill-height" :lazy-validation="true" v-model="issueTagFormValid">

                <v-row dense>
                    <v-col cols="12">
                        <v-text-field color="#c42111" outlined label="Tag Name" v-model="$props.editTagClone.issue_tag_name" :rules="[$store.state.validationFuncs.required($props.editTagClone.issue_tag_name, 'Tag Name'), $store.state.validationFuncs.noDuplicates($props.editTagClone.issue_tag_name, existingTagNames)]" />
                    </v-col>
                    <v-col cols="12">
                        <v-textarea color="#c42111" outlined label="Tag Description" v-model="$props.editTagClone.issue_tag_desc" />
                    </v-col>
                </v-row>

            </v-form>
        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="saveClick">Save</v-btn>
            <v-btn text @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
export default {
    name: 'EditIssueTag',
    props: ['editTagClone', 'existingTags'],
    components: {
    },
    data: () => ({
        issueTagFormValid: false,
        existingTagNames: []
    }),

    computed: {
    },

    methods: {
        saveClick: function() {
            if(this.$refs.issueTagForm.validate()) {
                this.$emit('save');
            }
        }
    },

    created() {
        this.existingTagNames = this.$props.existingTags.filter(t => {
            return t.issue_tag_id != this.$props.editTagClone.issue_tag_id;
        }).map(t => {
            return t.issue_tag_name;
        });
    },

    mounted() {
    }
};
</script>

<style scoped>
</style>
